/**
 * News item on 2025/09/27
 */
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Container,
  Typography,
  List,
  ListItem,
  Link,
} from "@mui/material";
import PageLayout from "../../components/Common/PageLayout";
import PageBanner from "../../components/Common/PageBanner";

/**
 *
 * @returns {JSX.Element}
 * @component
 */
const NewsAcetaminophenFetal = () => {
  return (
    <PageLayout
      pageName="SMFA Statement on the Use of Acetaminophen During Fetal Surgery"
      checkComingSoon
    >
      <PageBanner
        mainTitle="SMFA Statement on the Use of Acetaminophen During Fetal Surgery"
        pageTitle=""
        dense
      />
      {/* About Area */}
      <Box component="section" sx={{ py: 8 }}>
        <Container maxWidth="md">
          <Box sx={{ display: "flex", justifyContent: "center", mb: 4 }}>
            <img
              src="/img/smfa-logo-letterhead.jpg"
              alt="SMFA Logo"
              style={{ maxWidth: "300px", height: "auto" }}
            />
          </Box>
          <Typography
            variant="body1"
            paragraph
            sx={{ mb: 4, textAlign: "justify" }}
          >
            The Society for Maternal-Fetal Anesthesia (SMFA) affirms that
            acetaminophen remains an appropriate, safe, and essential
            therapeutic option during pregnancy when used as recommended.
            Extensive research to date has not demonstrated a causal
            relationship between acetaminophen exposure in pregnancy and adverse
            neurodevelopmental outcomes, including autism spectrum disorder,
            ADHD, or intellectual disability. In contrast, untreated maternal
            fever and pain are well-documented risks to both maternal and fetal
            health. The SMFA cautions against misinterpreting limited or
            methodologically flawed studies and emphasizes that clinical
            decisions should be guided by the best available evidence,
            patient-provider dialogue, and the need to balance risks and
            benefits. Accordingly, the SMFA will continue to support the use of
            acetaminophen for perioperative analgesia and fever management in
            patients undergoing fetal surgery. The SMFA remains committed to
            providing clear, evidence-informed guidance to ensure optimal
            maternal, fetal, and child health outcomes.
          </Typography>
          <Typography variant="h6" sx={{ mb: 0 }}>
            References
          </Typography>
          <List sx={{ pl: 2 }}>
            <ListItem
              sx={{ flexDirection: "column", alignItems: "flex-start" }}
            >
              <Typography component="div">
                <Link
                  component={RouterLink}
                  to="https://jamanetwork.com/journals/jama/fullarticle/10.1001/jama.2024.3172"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Acetaminophen Use During Pregnancy and Children's Risk of
                  Autism, ADHD, and Intellectual Disability.
                </Link>
              </Typography>
              <Typography variant="body2">
                Ahlqvist VH, Sjöqvist H, Dalman C, et al. JAMA.
                2024;331(14):1205-1214.
              </Typography>
            </ListItem>
            <ListItem
              sx={{ flexDirection: "column", alignItems: "flex-start" }}
            >
              <Typography component="div">
                <Link
                  component={RouterLink}
                  to="https://pubmed.ncbi.nlm.nih.gov/40898607"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Maternal Acetaminophen Use and Offspring's Neurodevelopmental
                  Outcome: A Nationwide Birth Cohort Study.
                </Link>
              </Typography>
              <Typography variant="body2">
                Okubo Y, Hayakawa I, Sugitate R, Narai H. Paediatric and
                Perinatal Epidemiology. 2025.
              </Typography>
            </ListItem>
            <ListItem
              sx={{ flexDirection: "column", alignItems: "flex-start" }}
            >
              <Typography component="div">
                <Link
                  component={RouterLink}
                  to="https://pubmed.ncbi.nlm.nih.gov/39637384"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Acetaminophen in Pregnancy and Attention-Deficit and
                  Hyperactivity Disorder and Autism Spectrum Disorder.
                </Link>
              </Typography>
              <Typography variant="body2">
                Damkier P, Gram EB, Ceulemans M, et al. Obstetrics and
                Gynecology. 2025;145(2):168-176.
              </Typography>
            </ListItem>
          </List>
          <Typography
            variant="caption"
            sx={{ mt: 2, display: "block", textAlign: "center" }}
          >
            Last updated: September 26, 2025
          </Typography>
        </Container>
      </Box>
    </PageLayout>
  );
};

export default NewsAcetaminophenFetal;
